import {
  ADMIN_REQUST,
  ADMIN_REQUST_SUCCESS,
  ADMIN_REQUST_FAILURE,
} from 'store/requestPost/requestPostAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const requestPostReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_REQUST:
      return { ...state, loading: true };
    case ADMIN_REQUST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case ADMIN_REQUST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default requestPostReducer;
